import React from "react";
import { useTranslation } from "react-i18next";
import playIcon from '../../assets/img/icon/play-icon-white.svg';
import {publishedDateShow, convertTimestampToString} from "../../utils/date"

const NewsThumbnail = ({item}) =>{
  return(
    <li>
      <figure>
        <a href={item.url}>
          <img src={item.image} width="439" height="247" alt="" />
        </a>
      </figure>
      <h3 className="fz15 fwn mg0 spacing-t-sm">
        <a className="link" href={item.url}>{item.title}</a>
      </h3>
      <div className="spacing-t-xxs quiet fz13">
        <a className="link" href={`${item.scheme || 'https'}://${item.domain}`}>{item.site_name}</a>,
        <time dateTime={convertTimestampToString(item.published_at)}>{publishedDateShow(item.published_at)}</time>
      </div>
    </li>
  )
}
const VideoThumbnail = ({item}) =>{
  return(
    <li>
      <figure className="has-decor">
        <a href={item.url}>
          <img src={item.image} width="439" height="247" alt="" />
          <span className="decor location-cc gap-re">
            <img src={playIcon} width="25" height="25" alt="" />
          </span>
          <time className="decor location-br gap-lg txt" dateTime="PT17M46S">
            <span>17:46</span>
          </time>
        </a>
      </figure>
      <h3 className="fz15 fwn mg0 spacing-t-sm">
        <a className="link" href={item.url}>{item.title}</a>
      </h3>
      <div className="spacing-t-xxs quiet fz13">
        <a className="link" href={`${item.scheme || 'https'}://${item.domain}`}>{item.site_name}</a>,
        <time dateTime="2021-09-30">32 min ago</time>
      </div>
    </li>
  )
}

export function NewsSection() {
  const items = [
    {
      "url": "www.christianpost.com/news/how-christian-celebrities-can-avoid-failing-the-fame-test.html?page=2",
      "title": "Crisis in church leadership: How celebrity pastors can avoid failing the fame test",
      "excerpt": "What drives the dysfunction and lack of health seen in many church leaders today? Why do so many pastors in Western evangelicism fail the fame test despite the biblical example set by Jesus Himself?",
      "image": "https://cdn.christianpost.com/files/original/thumbnail/24/40/244095.jpg",
      "published_at": 1633866430000,
      "site_name": "The Christian Post",
      "domain": "www.christianpost.com",
    },
    {
      "url": "www.christianpost.com/news/how-christian-celebrities-can-avoid-failing-the-fame-test.html?page=2",
      "title": "This Is What Life Is Like for Us A Year After The Tree of Life Synagogue Mass Shooting",
      "excerpt": "Arkansas lawmakers have overwhelmingly passed a bill that would, if enacted, prohibit Planned Parenthood and other abortion providers from providing resources to public schools.",
      "image": "https://external-content.duckduckgo.com/ip3/www.designcrowd.com.ico",
      "published_at": 1633866430000,
      "site_name": "The Christian Post",
      "domain": "east.slcschools.org",
    },
    {
      "url": "www.christianpost.com/news/how-christian-celebrities-can-avoid-failing-the-fame-test.html?page=2",
      "title": "Meet Sema Bal, Who Reads Fortunes Through Turkish Coffee Grounds",
      "excerpt": "While the numbers are still coming in, early estimates are projecting more than 200 million people watched Pulse&#39;s Worldwide Good Friday Broadcast. Already, more than 1.3 million people have responded to the Gospel, indicating their desire to follow Jesus.",
      "image": "https://external-content.duckduckgo.com/ip3/www.logodesign.net.ico",
      "published_at": 1633866430000,
      "site_name": "The Christian Post",
      "domain": "east.slcschools.org",
    },
  ]

  return (
    <section className="spacing-b-md">
        <header className="header-line-minor l-justify">
            <h2 className="flex-main upper">News</h2>
            <a className="fz13 quiet link" href="/">More</a>
        </header>
        <ul className="search-sidebar-1-2 no-bullet">
          {
            items.map((item, index) =>(
                <NewsThumbnail key={`news-section-item-${index + 1}`} item={item}/>
            ))
          }
        </ul>
    </section>
  );
}

export function VideosSection() {
  const items = [
    {
      "url": "www.christianpost.com/news/how-christian-celebrities-can-avoid-failing-the-fame-test.html?page=2",
      "title": "Crisis in church leadership: How celebrity pastors can avoid failing the fame test",
      "excerpt": "What drives the dysfunction and lack of health seen in many church leaders today? Why do so many pastors in Western evangelicism fail the fame test despite the biblical example set by Jesus Himself?",
      "image": "https://cdn.christianpost.com/files/original/thumbnail/24/40/244095.jpg",
      "published_at": 1633866430000,
      "site_name": "Youtube",
      "domain": "www.youtube.com",
    },
    {
      "url": "www.christianpost.com/news/how-christian-celebrities-can-avoid-failing-the-fame-test.html?page=2",
      "title": "This Is What Life Is Like for Us A Year After The Tree of Life Synagogue Mass Shooting",
      "excerpt": "Arkansas lawmakers have overwhelmingly passed a bill that would, if enacted, prohibit Planned Parenthood and other abortion providers from providing resources to public schools.",
      "image": "https://external-content.duckduckgo.com/ip3/www.designcrowd.com.ico",
      "published_at": 1633866430000,
      "site_name": "Vimeo",
      "domain": "www.vimeo.com",
    },
    {
      "url": "www.christianpost.com/news/how-christian-celebrities-can-avoid-failing-the-fame-test.html?page=2",
      "title": "Meet Sema Bal, Who Reads Fortunes Through Turkish Coffee Grounds",
      "excerpt": "While the numbers are still coming in, early estimates are projecting more than 200 million people watched Pulse&#39;s Worldwide Good Friday Broadcast. Already, more than 1.3 million people have responded to the Gospel, indicating their desire to follow Jesus.",
      "image": "https://external-content.duckduckgo.com/ip3/www.logodesign.net.ico",
      "published_at": 1633866430000,
      "site_name": "Youtube",
      "domain": "www.youtube.com",
    },
  ]
  return (
    <section className="spacing-b-md">
      <header className="header-line-minor l-justify">
        <h2 className="flex-main upper">Videos</h2>
        <a className="fz13 quiet link" href="search-videos.html">More</a>
      </header>
      <ul className="search-sidebar-1-2 no-bullet">
        {
          items.map((item, index) =>(
            <VideoThumbnail key={`video-section-item-${index + 1}`} item={item}/>
          ))
        }
      </ul>
    </section>
  );
}

export function RelatedSearch(){
  const items = [
    {
      url:"/search?q=east-conference",
      title:"east conference"
    },
    {
      url:"/search?q=east-high-school",
      title:"east-high-school"
    },
    {
      url:"/search?q=east-and-west",
      title:"east-and-west"
    },
    {
      url:"/search?q=east-initiative",
      title:"east-initiative"
    },
    {
      url:"/search?q=east-in-hindi",
      title:"east-in-hindi"
    },
    {
      url:"/search?q=what-is-east-in-school",
      title:"what-is-east-in-school"
    },
    {
      url:"/search?q=east-trauma",
      title:"east-trauma"
    },
  ]
  return(
    <section className="spacing-b-md">
      <header className="header-line-minor">
        <h2 className="upper">Related Search</h2>
      </header>
      <ul className="keyword-list no-bullet">
        {
          items.map((item, index) =>(
            <li>
              <a className="pill light link-color" href={item.url}>
                <span className="txt">{item.title}</span>
              </a>
            </li>
          ))
        }
      </ul>
    </section>
  )
}

export function Publishers(){
  const { t } = useTranslation();
  const items = {
    'us': [
      {
        url:"https://www.christianpost.com",
        title:"The Christian Post"
      },
      {
        url:"https://www1.cbn.com/cbnnews",
        title:"CBN"
      },
      {
        url:"https://www.christiantoday.com",
        title:"Christian Today"
      },
      {
	url:"https://christianitytoday.com",
        title:"Christianity Today"
      },
      {
        url:"https://www.baptistpress.com",
        title:"Baptist Press"
      },
      {
	url:"https://catholicnewsagency.com",
        title:"Catholic News Agency"
      },
      {
	url:"https://morningstarnews.org",
        title:"Morningstar News"
      },
      {
	url:"https://relevantmagazine.com",
        title:"RELEVANT"
      },
      {
	url:"https://wng.org",
        title:"WORLD"
      },
      {
        url:"https://cruxnow.com",
        title:"Crux"
      },
      {
        url:"https://wordandway.org",
        title:"Word&Way"
      },
      {
        url:"https://decisionmagazine.com",
        title:"Decision Magazine"
      },
      {
        url:"https://www.worldwatchmonitor.org",
        title:"World Watch Monitor"
      },
      {
        url:"https://christianchronicle.org",
        title:"The Christian Chronicle"
      },
      {
        url:"https://christiannewsjournal.com",
        title:"Christian News Journal"
      },
    ],
    'kr': [
      {
        url:"http://www.kmib.co.kr/news/",
        title:"국민일보"
      },
      {
        url:"http://www.igoodnews.net/",
        title:"아이굿뉴스"
      },
      {
        url:"https://www.missionews.co.kr/",
        title:"선교신문"
      },
      {
        url:"https://www.christiandaily.co.kr/",
        title:"기독일보"
      },
      {
        url:"https://www.cts.tv/news",
        title:"CTS"
      },
      {
        url:"https://www.christiantoday.co.kr/",
        title:"크리스천투데이"
      },
    ],
    'br': [
      {
        url:"https://www.guiame.com.br/",
        title:"Guiame"
      },
      {
        url:"https://noticias.gospelmais.com.br/",
        title:"Gospel Mais"
      },
      {
        url:"https://www.gospelprime.com.br/",
        title:"Gospel Prime"
      },
      {
        url:"https://www.fuxicogospel.com.br/",
        title:"Fuxico Gospel"
      },
    ],
  }[process.env.REACT_APP_PUBLISHERS_COUNTRY] || [];
  
  return(
    <section className="spacing-b-md">
      <header className="header-line-minor">
        <h2 className="upper">{t('news.publishers')}</h2>
      </header>
      <ul className="list xs no-bullet">
        {items.map((item, index) =>(
          <li>
            <a className="link-color fz13" href={item.url}>
              <span className="txt">{item.title}</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  )
}

export function TopNewsVideos(){
  const items = [
    {
      "url": "www.christianpost.com/news/how-christian-celebrities-can-avoid-failing-the-fame-test.html?page=2",
      "title": "Crisis in church leadership: How celebrity pastors can avoid failing the fame test",
      "excerpt": "What drives the dysfunction and lack of health seen in many church leaders today? Why do so many pastors in Western evangelicism fail the fame test despite the biblical example set by Jesus Himself?",
      "image": "https://cdn.christianpost.com/files/original/thumbnail/24/40/244095.jpg",
      "published_at": 1633866430000,
      "site_name": "The Christian Post",
      "domain": "www.christianpost.com",
    },
    {
      "url": "www.christianpost.com/news/how-christian-celebrities-can-avoid-failing-the-fame-test.html?page=2",
      "title": "This Is What Life Is Like for Us A Year After The Tree of Life Synagogue Mass Shooting",
      "excerpt": "Arkansas lawmakers have overwhelmingly passed a bill that would, if enacted, prohibit Planned Parenthood and other abortion providers from providing resources to public schools.",
      "image": "https://external-content.duckduckgo.com/ip3/www.designcrowd.com.ico",
      "published_at": 1633866430000,
      "site_name": "The Christian Post",
      "domain": "east.slcschools.org",
    },
    {
      "url": "www.christianpost.com/news/how-christian-celebrities-can-avoid-failing-the-fame-test.html?page=2",
      "title": "Meet Sema Bal, Who Reads Fortunes Through Turkish Coffee Grounds",
      "excerpt": "While the numbers are still coming in, early estimates are projecting more than 200 million people watched Pulse&#39;s Worldwide Good Friday Broadcast. Already, more than 1.3 million people have responded to the Gospel, indicating their desire to follow Jesus.",
      "image": "https://external-content.duckduckgo.com/ip3/www.logodesign.net.ico",
      "published_at": 1633866430000,
      "site_name": "The Christian Post",
      "domain": "east.slcschools.org",
    },
  ]

  return(
    <section className="spacing-b-md">
      <header className="header-line-minor">
        <h2 className="upper">Top News Videos</h2>
      </header>
      <ul className="search-sidebar-1-2 no-bullet">
        {
          items.map((item, index) =>(
            <VideoThumbnail key={`top-news-videos-section-item-${index + 1}`} item={item}/>
          ))
        }
      </ul>
    </section>
  )
}
